export const UNKOWN_EXCEPTION : string = 'Ocorreu um erro não tratado. Veja mais no console.';